// Presentation-only aggregation. Canonical log rows retain their full dice and damage-type detail.
type Group = { id: string; expires: number; rolled: number; applied: number; known: boolean; verb: string; reason: string; resisted: boolean; immune: boolean; vulnerable: boolean };
export class RollWaterfallGroups {
    private groups = new Map<string, Group>();
    private sequence = 0;

    add(roll: Record<string, unknown>, category: string, target: string, now = Date.now(), component = ''): {
        rollId: string; amount: number; appliedAmount: number | null; summaryVerb: string; zeroReason: string; resisted: boolean; immune: boolean; vulnerable: boolean;
    } | null {
        if (roll.roll_result === null || roll.roll_result === undefined || roll.roll_result === '') return null;
        const final = Number(roll.roll_result);
        if (!Number.isFinite(final) || final < 0) return null;
        const raw = roll.roll_feedback;
        const feedback = raw && typeof raw === 'object' && !Array.isArray(raw) ? raw as Record<string, unknown> : {};
        const known = typeof feedback.rolled === 'number' && Number.isFinite(feedback.rolled) && feedback.rolled >= 0
            && typeof feedback.applied === 'number' && Number.isFinite(feedback.applied) && feedback.applied >= 0
            && ['taken', 'restored', 'gained', 'spent'].includes(String(feedback.verb));
        const rolled = known ? Number(feedback.rolled) : final;
        const applied = known ? Number(feedback.applied) : final;
        const verb = known ? String(feedback.verb) : '';
        const reason = known && applied === 0 && ['immune', 'fully resisted', 'already full', 'healing blocked', 'dead', 'stronger effect active'].includes(String(feedback.reason))
            ? String(feedback.reason) : '';
        const identity = String(roll.roll_id || roll.roll_i || `anonymous-${++this.sequence}`);
        // The target, actor, encounter and category keep unrelated casts and recipients apart.
        // A component discriminator lets damage stay compact per damage type without merging a
        // mixed Fire/Cold action into one misleading maximum. Resources deliberately omit it.
        const key = JSON.stringify([roll.encounter_id || '', identity, roll.roll_by || roll.roll_creature_id || '', target, category, component]);
        for (const [key, group] of this.groups) if (group.expires <= now) this.groups.delete(key);
        let group = this.groups.get(key);
        if (!group) {
            group = { id: `waterfall-${identity}-${++this.sequence}`, expires: now + 5600, rolled: 0, applied: 0, known: true, verb, reason, resisted: false, immune: false, vulnerable: false };
            this.groups.set(key, group);
            if (this.groups.size > 200) this.groups.delete(this.groups.keys().next().value!);
        }
        group.rolled += rolled;
        group.applied += applied;
        group.resisted ||= feedback.resisted === true || reason === 'fully resisted';
        group.immune ||= feedback.immune === true || reason === 'immune';
        group.vulnerable ||= feedback.vulnerable === true;
        group.known = group.known && known && group.verb === verb;
        // Never label a mixed or partially successful action with one fragment's failure reason.
        if (group.reason !== reason) group.reason = '';
        return { rollId: group.id, amount: group.known ? group.rolled : (category === 'damage_roll' ? group.applied : group.rolled),
            appliedAmount: group.known ? group.applied : null, summaryVerb: group.known ? group.verb : '',
            zeroReason: group.known && group.applied === 0 ? group.reason : '', resisted: group.resisted,
            immune: group.immune, vulnerable: group.vulnerable };
    }
}
